































import Vue, {PropType} from 'vue';
import type {Developer} from '@/types';
// import EditCustomer from '@/components/actions/EditCustomer.vue';
// import DeleteCustomer from '@/components/actions/DeleteCustomer.vue';
// import RevokeAcademicStatus from '@/components/actions/RevokeAcademicStatus.vue';

export default Vue.extend({
  // components: {RevokeAcademicStatus, DeleteCustomer, EditCustomer},
  props: {
    id: {
      type: Number as PropType<number>,
      required: true
    }
  },
  data(): { model: Developer | null } {
    return {
      model: null
    };
  },
  watch: {
    $hash() {
      this.load();
    }
  },
  computed: {

  },
  methods: {
    load() {
      this.$store.api.developer(this.id).then(it => {
        this.model = it;
      }).catch(this.setError);
    }
  },
  mounted() {
    this.load();
  }
});
